import { useState, useEffect, useRef } from "react";
import { Icon } from "components";
import { metalColors, cabinetryColors, woodColors } from "settings/colors";
import { woodsTextures, metalTextures, marbleTextures, fabricTextures, without } from "textures";
import s from "../Panel/Panel.module.css";

const ViewMenu = ({ submit }) => {
    const [material, setMaterial] = useState({
        color: null,
        type: null,
        texture: null,
        imgW: 100,
        imgH: 100,
        isRemove: false,
    });
    const [usersTextures, setUsersTextures] = useState([]);
    const [needUpdate, setNeedUpdate] = useState(false);

    const filePicker = useRef(null);

    useEffect(() => {
        // console.log("isFirst: ", isFirst);
        // console.log("needUpdate: ", needUpdate);
        if (needUpdate) {
            submit(material);
            setNeedUpdate(false);
            // setMaterial((prev) => ({ ...prev, isRemove: false }));
        }
    }, [needUpdate, submit, material]);

    const chooseFile = (file) => {
        const image = new Image(1024, 1024);
        const url = window.URL.createObjectURL(file);
        image.src = url;
        setUsersTextures((prev) => [...prev, url]);
    };

    const handlePick = () => {
        filePicker.current.click();
    };

    const setProp = (name, value) => {
        setMaterial((prev) => ({ ...prev, [name]: value }));
        if (name === "isRemove") setMaterial((prev) => ({ ...prev, texture: null }));
        if (name === "texture") setMaterial((prev) => ({ ...prev, isRemove: false }));
        setNeedUpdate(true);
    };

    const onChange = (e) => {
        const { value, name } = e.target;
        setMaterial((prev) => ({ ...prev, [name]: value }));
    };

    const valueCorrection = (e) => {
        const { name } = e.target;
        // const { min, max } = range[name];
        const max = 1000;
        const min = 1;
        const value = material[name];
        setMaterial((prev) => ({
            ...prev,
            [name]: Math.min(max, Math.max(value, min)),
        }));
        setNeedUpdate(true);
    };

    return (
        <div className={s.container}>
            <div className={s.prop}>
                <p>Metal colors:</p>
                <ul className={s.colorList}>
                    {metalColors.map((color) => (
                        <li
                            className={color === material.color ? s.active : s.item}
                            key={color}
                            onClick={() => setProp("color", color)}
                        >
                            <div className={s.color} style={{ backgroundColor: color }}></div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={s.prop}>
                <p>Cabinetry colors:</p>
                <ul className={s.colorList}>
                    {cabinetryColors.map((color) => (
                        <li
                            className={color === material.color ? s.active : s.item}
                            key={color}
                            onClick={() => setProp("color", color)}
                        >
                            <div className={s.color} style={{ backgroundColor: color }}></div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={s.prop}>
                <p>Wood colors:</p>
                <ul className={s.colorList}>
                    {woodColors.map((color) => (
                        <li
                            className={color === material.color ? s.active : s.item}
                            key={color}
                            onClick={() => setProp("color", color)}
                        >
                            <div className={s.color} style={{ backgroundColor: color }}></div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className={s.flexBox + " " + s.prop}>
                <p>Texture size (cm)</p>
                <input
                    name="imgW"
                    className={s.input}
                    value={material.imgW}
                    onChange={onChange}
                    onBlur={valueCorrection}
                    type="number"
                />
                <p>X</p>
                <input
                    name="imgH"
                    className={s.input}
                    value={material.imgH}
                    onChange={onChange}
                    onBlur={valueCorrection}
                    type="number"
                />
            </div>

            {/* <div className={s.prop}>
                <p>Texture repetition</p>
                <input
                    className={s.count}
                    type="range"
                    min={1}
                    max={20}
                    value={material.repeat}
                    onChange={(e) => setProp("repeat", e.target.value)}
                />
            </div> */}

            <div className={s.sendFile}>
                <p>User's Textures</p>
                <ul className={s.colorList}>
                    <div className={s.texture} onClick={handlePick}>
                        <Icon icon="upload" w={34} />
                        <p className={s.text}>upload</p>
                        <input
                            className="hidden"
                            type="file"
                            ref={filePicker}
                            accept=".jpg, .jpeg, .png, .webp"
                            onChange={(e) => chooseFile(e.target.files[0])}
                        />
                    </div>
                    {usersTextures.map((image) => (
                        <li
                            className={image === material.texture ? s.activeTexture : s.texture}
                            key={image}
                            onClick={() => setProp("texture", image)}
                        >
                            <img src={image} width={60} alt="" />
                        </li>
                    ))}
                </ul>
            </div>

            <div className={s.prop}>
                <p>Wood textures:</p>
                <ul className={s.colorList}>
                    <li
                        className={material.isRemove ? s.activeTexture : s.texture}
                        onClick={() => setProp("isRemove", true)}
                    >
                        <img src={without} width={60} alt="" />
                    </li>
                    {woodsTextures.map((image) => (
                        <li
                            className={image === material.texture ? s.activeTexture : s.texture}
                            key={image}
                            onClick={() => setProp("texture", image)}
                        >
                            <img src={image} width={60} alt="" />
                        </li>
                    ))}
                </ul>
            </div>

            <div className={s.prop}>
                <p>Metal textures:</p>
                <ul className={s.colorList}>
                    {metalTextures.map((image) => (
                        <li
                            className={image === material.texture ? s.activeTexture : s.texture}
                            key={image}
                            onClick={() => setProp("texture", image)}
                        >
                            <img src={image} width={60} alt="" />
                        </li>
                    ))}
                </ul>
            </div>

            <div className={s.prop}>
                <p>Stone textures:</p>
                <ul className={s.colorList}>
                    {marbleTextures.map((image) => (
                        <li
                            className={image === material.texture ? s.activeTexture : s.texture}
                            key={image}
                            onClick={() => setProp("texture", image)}
                        >
                            <img src={image} width={60} alt="" />
                        </li>
                    ))}
                </ul>
            </div>

            <div className={s.prop}>
                <p>Fabric textures:</p>
                <ul className={s.colorList}>
                    {fabricTextures.map((image) => (
                        <li
                            className={image === material.texture ? s.activeTexture : s.texture}
                            key={image}
                            onClick={() => setProp("texture", image)}
                        >
                            <img src={image} width={60} alt="" />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ViewMenu;
